export default __webpack_public_path__ + "meetingroomdetails2.json";